import {createConfirmation} from 'react-confirm';

import ConfirmModal from '../components/general/confirm-modal';

const defaultConfirmation = createConfirmation(ConfirmModal);

/* eslint-disable-next-line no-shadow */
export const confirm = (message, options = {}) => defaultConfirmation({message, ...options});
